<!-- Main Content -->
<div
  class="w-full max-w-6xl mx-auto flex flex-col gap-4 border border-gray-300 rounded-lg bg-white"
>
  <lib-feature-header
    [title]="title()"
    [isLoading]="store.loading()"
    (closeClick)="onCancel()"
  >
    @if (!store.isCreateMode()) {
    <span
      class="rounded-full px-2.5 py-1 text-xs font-medium"
      [class.bg-green-100]="store.sourceChannel()?.is_active"
      [class.text-green-700]="store.sourceChannel()?.is_active"
      [class.bg-gray-100]="!store.sourceChannel()?.is_active"
      [class.text-gray-600]="!store.sourceChannel()?.is_active"
    >
      {{ store.sourceChannel()?.is_active ? 'Active' : 'Inactive' }}
    </span>
    }
  </lib-feature-header>

  @if (store.error()) {
  <div class="px-4">
    <lib-error-alert
      [error]="store.error() || 'An unexpected error occurred'"
    />
  </div>
  }

  <form [formGroup]="form" class="p-4 flex flex-col gap-4">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <sb-text-input
        id="label"
        formControlName="label"
        label="Label"
        placeholder="Enter source channel label"
        [required]="true"
        [readonly]="store.loading() || !canSave()"
      />

      <sb-text-input
        id="code"
        formControlName="code"
        label="Code"
        placeholder="Enter unique source channel code"
        [required]="true"
        [readonly]="store.loading() || !store.isCreateMode() || !canSave()"
        helpText="Code cannot be changed after creation."
      />

      <sb-text-input
        id="display_order"
        formControlName="display_order"
        label="Display Order"
        type="number"
        min="0"
        step="1"
        placeholder="0"
        [readonly]="store.loading() || !canSave()"
      />

      <label
        class="flex items-start gap-3 rounded-md border border-gray-200 p-3 text-sm text-gray-700"
      >
        <input
          type="checkbox"
          formControlName="is_active"
          class="mt-0.5 h-4 w-4 rounded border-gray-300 text-orange-600 focus:ring-orange-500 disabled:cursor-not-allowed"
          [disabled]="store.loading() || !canSave()"
        />
        <span class="flex flex-col gap-1">
          <span class="font-medium text-gray-900">Active</span>
          <span class="text-gray-500">
            Active source channels are available when recording referrals.
          </span>
        </span>
      </label>

      <label
        class="md:col-span-2 flex items-start gap-3 rounded-md border border-gray-200 p-3 text-sm text-gray-700"
      >
        <input
          type="checkbox"
          formControlName="requires_additional_info"
          class="mt-0.5 h-4 w-4 rounded border-gray-300 text-orange-600 focus:ring-orange-500 disabled:cursor-not-allowed"
          [disabled]="store.loading() || !canSave()"
        />
        <span class="flex flex-col gap-1">
          <span class="font-medium text-gray-900">
            Requires additional information
          </span>
          <span class="text-gray-500">
            Show an additional information field when this source channel is
            selected on a referral.
          </span>
        </span>
      </label>
    </div>
  </form>

  <!-- Form Actions -->
  <div class="px-4 pb-4">
    <div class="flex justify-end space-x-4">
      <shared-submit-button
        [buttonText]="store.isCreateMode() ? 'Create' : 'Save'"
        [disabled]="form.invalid || store.loading() || !canSave()"
        [isLoading]="store.loading()"
        (buttonClick)="onSubmit()"
      />

      <shared-submit-button
        [buttonText]="'Cancel'"
        [variant]="'secondary'"
        (buttonClick)="onCancel()"
      />
    </div>
  </div>
</div>
